import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LEARNING_PORTFOLIO_FEATURE_KEY } from '../keys';
import { LearningPortfolioState } from '../reducers/learning-portfolio.reducer';

const selectState = createFeatureSelector<LearningPortfolioState>(LEARNING_PORTFOLIO_FEATURE_KEY);

const selectNotesSlice = createSelector(selectState, (state) => (state.notesKey ? (state.notes[state.notesKey] ?? null) : null));

export const selectNotes = createSelector(selectNotesSlice, (slice) => slice?.data?.items ?? null);
export const selectNotesTotal = createSelector(selectNotesSlice, (slice) => slice?.data?.total ?? null);
export const selectNotesLoaded = createSelector(selectNotesSlice, (slice) => slice?.loaded ?? null);
export const selectNotesLoading = createSelector(selectNotesSlice, (slice) => slice?.loading ?? false);

const selectNoteSlice = (id: string) => createSelector(selectState, (state) => state.note[id] ?? null);

export const selectNote = (id: string) => createSelector(selectNoteSlice(id), (slice) => slice?.data ?? null);
export const selectNoteLoaded = (id: string) => createSelector(selectNoteSlice(id), (slice) => slice?.loaded ?? null);
export const selectNoteLoading = (id: string) => createSelector(selectNoteSlice(id), (slice) => slice?.loading ?? false);

export const selectCategories = createSelector(selectState, (state) => state.categories.data);
export const selectCategoriesSaving = createSelector(selectState, (state) => state.categoriesSaving);
export const selectCreatedCategory = createSelector(selectState, (state) => state.createdCategory);

export const selectAttachments = createSelector(selectState, (state) => state.attachments.items);
export const selectPendingUploads = createSelector(selectState, (state) => state.attachments.pending);
export const selectAttachmentsUploading = createSelector(selectState, (state) => state.attachments.pending.length > 0);
export const selectAttachmentsFailed = createSelector(selectState, (state) => state.attachments.failed);

export const selectSaving = createSelector(selectState, (state) => state.saving);
export const selectSaved = createSelector(selectState, (state) => state.saved);
export const selectDeleted = createSelector(selectState, (state) => state.deleted);
